module.exports = __webpack_public_path__ + "img/slide-5.5378878d.png";